import { groupBy } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import withCurrentUser from 'hoc/withCurrentUser';
import { sortList, Spinner, position, colors, font } from '@zipdrug/ui';
import { StyleSheet } from 'aphrodite/no-important';
import SettingsAccordionList from '../SettingsAccordionList';
import TeamListInviteFormContainer from './TeamListInviteFormContainer';
import TeamListItem from './TeamListItem';

const sortTeamList = users => {
  const { false: pendingUsers = [], true: activeUsers = [] } = groupBy(
    users,
    ({ joined_at }) => !!joined_at,
  );

  return [...sortList(activeUsers, 'first_name'), ...pendingUsers];
};

const sx = StyleSheet.create({
  emptyState: {
    ...position.cover,
    color: colors.gray45,
    fontSize: font.size.medium,
    backgroundColor: '#FFFFFF',
    textColor: colors.gray45,
  },
});

const TeamList = ({ users, isSystemAdminOrAsc, isLoading, currentUser, onUserDeleted, isPharmacyTeam }) => (
  <>
    {!isLoading ? (
      <SettingsAccordionList
        createItemButtonText="Invite team member"
        createItemFormRenderer={<TeamListInviteFormContainer currentUser={currentUser} />}
        isSystemAdminOrAsc={isSystemAdminOrAsc}
        emptyStateText="Get started by inviting a team member"
        itemRenderer={<TeamListItem onUserDeleted={onUserDeleted} isPharmacyTeam={isPharmacyTeam} />}
        items={users}
        listLabel="member"
        sortList={sortTeamList}
        title="Team"
      />
    ) : (
      <Spinner loading={isLoading} styles={sx.emptyState} />
    )}
  </>
);

TeamList.propTypes = {
  users: PropTypes.array,
  isSystemAdminOrAsc: PropTypes.bool,
  isPharmacyTeam: PropTypes.bool,
  isLoading: PropTypes.bool,
  currentUser: PropTypes.object,
  onUserDeleted: PropTypes.func,
};

export default withCurrentUser(TeamList);
